module.exports = __webpack_public_path__ + "media/images/index_exchange_small_logo-acc558a5ddf40791c7055146fcf66fff.png";